<template>
<div class="row content l_bg-grey" ref="builderTop">
  <div class="row-inner">

    <div class="content-main" v-if="form.hasStructure">

      <div class="content-split">

        <h1 class="l_base" v-html="form.structure.title"></h1>

        <button @click="gotoQuote" class="button l_light l_icon" v-if="form.structure.handle == 'save'">
          <svg class="icon btn-icon"><use href="#arrow-left"></use></svg>
          <span class="btn-text">Modify quote</span>
        </button>

        <button @click="gotoQuote" class="button l_light l_icon" v-else-if="form.structure.handle == 'share'">
          <svg class="icon btn-icon"><use href="#arrow-left"></use></svg>
          <span class="btn-text">Return to quote</span>
        </button>

      </div>

      <div class="form-response" :class="{ 's_active' : form.isSuccess }">
        <div class="form-response-aside">
          <svg class="icon"><use xlink:href="#check-circle"></use></svg>
        </div>
        <div class="form-response-main" v-html="form.structure.successMessage"></div>
      </div>

      <form method="post" @submit="formSubmit" class="form-grid" :class="{ 's_loading' : form.isSubmitted }" ref="builderForm" novalidate="true" v-if="!form.isSuccess">

        <!-- loading -->
        <div class="loader">
          <svg class="circular-loader" viewBox="25 25 50 50" >
            <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#ffffff" stroke-width="3" />
          </svg>
          <p v-html="form.structure.loadingMessage"></p>
        </div>

        <!-- errors -->
        <div class="form-fieldset" v-if="form.formErrors.length || form.fieldErrors.length">
          <div class="form-group form-errors">
            <p class="has-error" v-for="error in form.formErrors" v-html="error"></p>
            <p class="has-error" v-for="(error, key) in form.fieldErrors" v-html="error"></p>
          </div>
        </div>

        <!-- main content -->
        <div class="form-group" v-html="form.structure.mainContent"></div>

        <input type="hidden" :name="window.csrfTokenName" :value="window.csrfTokenValue">

        <div class="form-fieldset" v-for="row in form.structure.formLayout" v-if="!_.isUndefined(v$)">

          <legend v-html="row.name" v-if="typeof row.name !== 'undefined' && row.name.length"></legend>

          <div v-for="field in row.fields" class="form-group" :class="[field.class, {'has-error' : v$[field.handle].$dirty && v$[field.handle].$error}, {'has-success' : v$[field.handle].$dirty && !v$[field.handle].$error}, {'s_active' : v$[field.handle].$model && v$[field.handle].$model !== null || form.focusField == field.handle}]" v-bind:key="field.id">

            <template v-if="field.type == 'submit'">
              <div :class="field.controlClass">
                <input
                  type="submit"
                  name="submitBtn"
                  class="btn"
                  ref="builderFormSubmit"
                  :class="field.inputClass"
                  :value="field.label" />
              </div>
            </template>

            <template v-else-if="field.type == 'hidden'">
              <input
                :type="field.type"
                :name="field.handle"
                :id="field.handle"
                :class="field.inputClass"
                v-model="fill[field.handle]"
                :placeholder="field.placeholder"
                :required="field.required ? true : false"
                @input="v$[field.handle].$touch()">
            </template>

            <template v-else-if="field.type == 'checkbox'">
              <div :class="field.controlClass">

                <div class="styledcheckbox">
                  <input
                    type="checkbox"
                    :name="field.handle"
                    :id="field.handle"
                    :value="field.onValue"
                    :required="field.required ? true : false"
                    :class="field.inputClass"
                    false-value=""
                    v-model="fill[field.handle]"
                    @change="v$[field.handle].$touch()" />
                  <label :class="field.labelClass" :for="field.handle">
                    <span class="checkbox-value"><span v-html="field.showLabel"></span></span>
                  </label>
                </div>

                <template v-if="v$[field.handle]">
                  <p v-if="v$[field.handle].$dirty && v$[field.handle].$error" class="has-error">
                    <span v-for="param in v$[field.handle].$params">
                      <span v-if="!v$[field.handle][param.type]">{{ errorMessages[param.type] }}</span>
                    </span>
                  </p>
                </template>

              </div>
            </template>

            <template v-else>

              <label :for="field.handle">
                {{ field.label }}
                <span class="help-block" v-if="field.instructions && !field.groupClass.includes('l_placeholder')" v-html="field.instructions"></span>
              </label>

              <div :class="field.controlClass">

                <template v-if="field.type == 'select'">
                  <select
                    :name="field.handle"
                    :id="field.handle"
                    :required="field.required ? true : false"
                    :class="field.inputClass"
                    v-model="fill[field.handle]"
                    @focus="handleFocus(v$[field.handle], field.handle)"
                    @blur="handleBlur(v$[field.handle])">
                    <option :value="``">Please select...</option>
                    <option v-for="opt in field.options" :value="opt.value">{{ opt.label }}</option>
                  </select>
                </template>

                <template v-else-if="field.type == 'textarea'">
                  <textarea
                    :name="field.handle"
                    :id="field.handle"
                    :required="field.required ? true : false"
                    :class="field.inputClass"
                    :rows="field.rows"
                    :data-min-rows="field.dataMinRows"
                    v-model="fill[field.handle]"
                    @input="handleTouch(v$[field.handle])"
                    @focus="handleFocus(v$[field.handle], field.handle)"
                    @blur="handleBlur(v$[field.handle])">
                  </textarea>
                </template>

                <template v-else-if="field.type == 'file'">
                  <input
                    :type="field.type"
                    :name="field.name"
                    :id="field.handle"
                    :class="field.inputClass"
                    v-model="fill[field.handle]"
                    :placeholder="field.placeholder"
                    :autocapitalize="field.autocapitalize"
                    :autocorrect="field.autocorrect"
                    :pattern="field.pattern"
                    data-multiple-caption="{count} files selected"
                    multiple
                    :required="field.required ? true : false"
                    @input="handleTouch(v$[field.handle])">
                  <label :for="field.handle">Choose a file</label>
                </template>

                <template v-else>
                  <input
                    :type="field.type"
                    :name="field.handle"
                    :id="field.handle"
                    :class="field.inputClass"
                    v-model="fill[field.handle]"
                    :placeholder="field.placeholder"
                    :autocapitalize="field.autocapitalize"
                    :autocorrect="field.autocorrect"
                    :pattern="field.pattern"
                    :required="field.required ? true : false"
                    @input="handleTouch(v$[field.handle])"
                    @focus="handleFocus(v$[field.handle], field.handle)"
                    @blur="handleBlur(v$[field.handle])">
                </template>

                <template v-if="v$[field.handle]">
                  <p v-if="v$[field.handle].$dirty && v$[field.handle].$error" class="has-error">
                    <span v-for="error in v$[field.handle].$errors">
                      <span v-if="!v$[field.handle][error.type]">
                        <!-- <span v-if="error.type == 'minLength'">
                          {{ errorMessages[error.type].replace('0', param.min) }}
                        </span>
                        <span v-else-if="error.type == 'maxLength'">
                          {{ errorMessages[error.type].replace('0', param.max) }}
                        </span> -->
                        <span>{{ error.$message }}</span>
                      </span>
                    </span>
                  </p>
                </template>

                <div class="help-block" v-if="field.instructions && field.groupClass.includes('l_placeholder')" v-html="field.instructions"></div>

              </div>

            </template>

          </div>

        </div>

      </form>

      <div class="button-group l_auto" v-if="form.structure.handle == 'save'">

        <!-- <a href="/builder/quote/" class="button l_light l_icon">
          <svg class="icon btn-icon"><use href="#arrow-left"></use></svg>
          <span class="btn-text">Return to quote</span>
        </a>

        &nbsp;&nbsp; -->

        <button @click="startNewQuote" class="button l_light l_icon" v-if="form.isSuccess">
          <svg class="icon btn-icon"><use href="#pencil"></use></svg>
          <span class="btn-text">Start a new quote</span>
        </button>

      </div>

    </div>

  </div>
</div>
</template>

<script setup>

var _ = require('lodash');
import axios from 'axios';

import { useVuelidate } from '@vuelidate/core'
import { minLength, required, email } from '@vuelidate/validators'

import { computed, ref, reactive, onMounted } from 'vue'

const props = defineProps([
  'structureInit',
  'quoteInit',
  'prefill',
  'rangeName'
])

import { useFormStore } from "@/stores/form";
const form = useFormStore();

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const fill = reactive({})
const rules = reactive({})
let v$;

const builderTop = ref(null);
const builderForm = ref(null);
const builderFormSubmit = ref(null);

onMounted(() => {

  // initiate quote
  if (!_.isEmpty(props.quoteInit)) {
    form.$patch((state) => {
      state.quote = props.quoteInit;
    })
  }

  // initiate structure
  if (!_.isEmpty(props.structureInit)) {
    form.$patch((state) => {
      state.structure = props.structureInit;
    })
  }

  // set field model with default value
  form.structure.formLayout.forEach( (row) => {

    row.fields.forEach( (field) => {

      field.controlClass = 'form-control';

      var defaultVal = '';
      if (props.prefill[field.handle]) {
        defaultVal = props.prefill[field.handle];
      } else if (form.quote[field.handle]) {
        defaultVal = form.quote[field.handle];
      } else if (form.prefill[field.handle]) {
        defaultVal = form.prefill[field.handle];
      }
      fill[field.handle] = defaultVal;

    });

  });

  // set rules
  if (!_.isEmpty(form.structure)) {
    form.structure.formLayout.forEach( (row) => {
      row.fields.forEach( (field) => {

        rules[field.handle] = {};

        // required
        if (typeof field.required !== 'undefined' && field.required) {
          rules[field.handle]['required'] = required;
        }

        // email
        if (field.type == 'email') {
          rules[field.handle]['email'] = email;
        }

        // max length
        if (typeof field.maxLength !== 'undefined') {
          rules[field.handle]['maxLength'] = maxLength(field.maxLength);
        }

        rules.$autoDirty = true;

      });
    });
  }

  v$ = useVuelidate(rules, fill)

  // auto submit if completed
  if (form.structure.handle == 'access' && fill['code'].length && fill['ref'].length) {
    formSubmit();
  }

  // show error if ref required and no ref
  if (form.structure.handle == 'access' && !fill['ref'].length) {
    form.formErrors.push('A valid quote reference is required');
  }

});

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

async function formSubmit(e) {

  if (!form.isSubmitted) {

    form.isSubmitted = true;
    form.formErrors = [];
    form.fieldErrors = [];

    const isFormCorrect = await v$.value.$validate()

    if (isFormCorrect) {

      scrollToTop();

      let data = new FormData(builderForm.value);
      let action = '?action=my-diy-module/quote/' + form.structure.handle;
      let method = 'post';

      axios({
        url: action ? action : window.location.href,
        method: method ? method : 'post',
        data: data,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          HTTP_X_REQUESTED_WITH: 'XMLHttpRequest',
        },
      })
      .then((responseObject) => {
        var response = responseObject.data;

        if (response.success) {

          setTimeout(() => {

            form.isSubmitted = false;
            form.isSuccess = true;

            if (typeof response.quote !== 'undefined') {
              form.quote = response.quote;
            }

            if (form.structure.handle == 'save') {
              // pre-push the range name and handle
              window.dataLayer.push({
                'range_name': form.quote.range.name,
                'range_handle': form.quote.range.handle,
              });
              let pushData = {
                'range_name': form.quote.range.name,
                'range_handle': form.quote.range.handle,
                'order_ref': form.quote.ref,
                'order_price': parseFloat(form.quote.total)
              };
              console.log('trigger: mydiy_quote_saved');
              console.log(pushData);
              if (typeof dataLayer !== 'undefined') gtag('event', 'mydiy_quote_saved', pushData);
            }

            if (form.structure.handle == 'edit') {
              setTimeout(() => {
                window.location.href = '/builder/access/' + form.quote.ref + '/';
              }, 500);
            }

            if (form.structure.handle == 'access') {

              var recalculated = true;
              if (typeof response.recalculated !== 'undefined') {
                recalculated = response.recalculated;
              }

              var isValid = false;
              if (typeof response.quote !== 'undefined') {
                if (response.quote.valid) isValid = true;
              }
              var newUrl = '/builder/';
              if (isValid) {
                newUrl += form.quote.range.handle + '/';
                newUrl += 'quote/';
              }
              if (recalculated) {
                newUrl += '?recalculated=yes';
              }

              setTimeout(() => {
                window.location.href = newUrl;
              }, 50);
            }

          }, 500);

          // console.log('Form posted successfully');
          // console.log(response.success);
          // console.log(response);

        } else if (response.errors) {

          form.isSubmitted = false;
          form.fieldErrors = response.errors;
          // this.isSuccess = false;

          console.log('Form failed to submit');
          console.log('Field Errors', response.errors);
          console.log('Form Errors', response.formErrors);

        } else {

          form.isSubmitted = false;

        }

      })
      .catch((error) => {

        form.isSubmitted = false;

        console.error('Error!');
        console.error(error);

      });

    } else {

      form.isSubmitted = false;

      scrollToTop();

    }

    e.preventDefault();
    return false;

  }

}

function handleTouch() {
  return;
}

function handleBlur() {
  return;
}

function handleFocus() {
  return;
}

function scrollToTop() {

  let offsetHeight = 0;
  if (document.querySelector('.header')) offsetHeight += document.querySelector('.header').offsetHeight;
  if (document.querySelector('.sitebanner')) offsetHeight += document.querySelector('.sitebanner').offsetHeight;
  const newScrollY = window.scrollY + builderTop.value.getBoundingClientRect().top - offsetHeight - 20;
  window.scroll(0, newScrollY);
  builderTop.value.focus();

}

function gotoQuote() {
  window.location.href = '/builder/' + form.quote.range.handle + '/quote/';
}

function startNewQuote() {
  window.location.href = '/builder/' + form.quote.range.handle + '/new/';
}

</script>
